<template>
    <div class="schoolAppInteDetail">
        <div class="top">
            <el-button
                @click="$router.go(-1)"
                type="default"
                size="medium"
            >返回
            </el-button>
        </div>
        <div
            class="body"
            v-if="moduleData.name"
            :style="`height: ${windowHeight-180}px;`"
        >
            <div class="application-info ">
                <div class="basic-info">
                    <div class="logo-wrapper">
                        <img
                            class="logo"
                            :src="isInstall ? moduleLogo : moduleData.logoUrl"
                        />
                        <uploader
                            showMode="image"
                            showResult="image"
                            :multiple="false"
                            :openDelete="false"
                            :value="updateModuleSchoolForm.moduleLogo"
                            :extList="['png', 'jpg', 'jpeg', 'bmp']"
                            :successCallback="logoUploadSuccessHandler"
                            v-if="isInstall"
                        ></uploader>
                    </div>
                    <div class="application-name">
                        <h3 class="application-name__main">{{isInstall ? moduleOtherName : moduleData.name}}</h3>
                        <div class="application-name__desc">{{moduleData.profile}}</div>
                    </div>
                    <span
                        class="setting-btn"
                        v-if="isInstall"
                        @click="handleUpdateModuleSchool"
                    >设置</span>

                    <el-dialog
                        title="应用名称设置"
                        :visible.sync="updateModuleSchoolShowDialog"
                        :close-on-press-escape='false'
                        width="600px"
                        :lock-scroll="false"
                        :close-on-click-modal='false'
                        :modal-append-to-body='false'
                    >
                        <div>
                            <el-form
                                ref="updateModuleSchoolForm"
                                :model="updateModuleSchoolForm"
                                :rules="updateModuleSchoolRules"
                                label-width="120px"
                            >
                                <el-form-item
                                    label="应用名称"
                                    prop="moduleOtherName"
                                >
                                    <el-input
                                        v-model.trim="updateModuleSchoolForm.moduleOtherName"
                                        style="width: 400px;"
                                    ></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                        <span
                            slot="footer"
                            class="dialog-footer"
                        >
              <el-button
                  size="medium"
                  @click="updateModuleSchoolShowDialog = false"
              >取 消</el-button>
              <el-button
                  size="medium"
                  type="primary"
                  @click="submitUpdateModuleSchool"
              >确定</el-button>
            </span>
                    </el-dialog>
                </div>
                <div class="detail-info clearfix">
                    <div class="detail-info__item">
                        <span>应用代号：</span>
                        <p>
                            {{moduleData.code}}
                        </p>
                    </div>
                    <div class="detail-info__item">
                        <span>验证域名：</span>
                        <p>
                            <el-tooltip
                                class="item"
                                effect="dark"
                                :content="moduleData.domainName"
                                placement="top"
                            >
                                <span>{{moduleData.domainName}}</span>
                            </el-tooltip>
                        </p>
                    </div>
                    <div class="detail-info__item">
                        <span> APPID：</span>
                        <p>
                            <el-tooltip
                                class="item"
                                effect="dark"
                                :content="moduleData.key"
                                placement="top"
                            >
                                <span>{{moduleData.key}}</span>
                            </el-tooltip>
                        </p>
                    </div>

                    <div class="detail-info__item">
                        <span>授信IP：</span>
                        <p class="ip-container">
                            <span>{{moduleData.ip}}</span>
                        </p>
                    </div>
                    <div class="detail-info__item">
                        <span>APPSECRET：</span>
                        <p>{{appSecret}}</p>
                    </div>
                    <div class="detail-info__item">
                        <span>自定义授信ip：</span>
                        <p class="custom-ip-container__outer">
                            <el-tooltip
                                class="item"
                                effect="dark"
                                :content="customIp"
                                placement="top"
                            >
                                <div class="custom-ip-container">
                                    {{customIp}}
                                </div>
                            </el-tooltip>
                            <span
                                class="setting-btn"
                                v-if="isInstall"
                                @click="setConfig('ip')"
                            >设置</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="application-configs clearfix">
                <div class="app-config">
                    <div class="app-config__title clearfix">
                        <h4>PC端入口集成</h4>
                        <span
                            data-status="1"
                            class="app-config__status"
                        >{{['', '已开启', '未开启'][moduleData.pcUrlOnOff]}}</span>
                    </div>
                    <div class="app-config__desc">
                        在校园统一门户平台，点击该应用可以直接进入该应用的PC端。
                        <div v-if="moduleData.pcUrlOnOff == 1" class="url">{{pcUrl}}</div>
                    </div>
                    <span
                        class="app-config__setting-btn"
                        data-config="pcEntry"
                        v-if="(moduleData.pcUrlOnOff == 1) && isInstall"
                        @click="setConfig('pc')"
                    >设置</span>
                </div>
                <div class="app-config">
                    <div class="app-config__title clearfix">
                        <h4>数据回调配置</h4>
                        <span
                            data-status="1"
                            class="app-config__status"
                        >{{['', '已开启', '未开启'][callbackUrlOnOff]}}</span>
                    </div>
                    <div class="app-config__desc">
                        将基础数据库的数据变更信息推送到回调地址。
                        <div v-if="callbackUrlOnOff == 1" class="url">{{moduleData.callbackUrl}}</div>
                    </div>
                    <span
                        class="app-config__setting-btn"
                        data-config="pcEntry"
                        v-if="(moduleData.callbackUrlOnOff == 1) && isInstall"
                        @click="setConfig('callback')"
                    >设置</span>
                </div>
                <div class="app-config">
                    <div class="app-config__title clearfix">
                        <h4>扫码登录配置</h4>
                    </div>
                    <div class="app-config__desc">
                        扫描二维码登录本应用的PC端。
                    </div>
                    <router-link
                        class="app-config__setting-btn"
                        :to="{
                        path: '/main/developmentSystem/permissionSystem/moduleApp/moduleAppScanConfigHelper',
                        query: {id}
                    }"
                        v-if="isInstall"
                    >查看详情
                    </router-link>
                </div>
                <div class="app-config">
                    <div class="app-config__title clearfix">
                        <h4>移动端入口集成</h4>
                        <span
                            data-status="1"
                            class="app-config__status"
                        >{{['', '已开启', '未开启'][moduleData.mobileUrlOnOff]}}</span>
                    </div>
                    <div class="app-config__desc">
                        在微校+主界面中点击应用图标直接进入应用内部。
                        <div v-if="moduleData.mobileUrlOnOff == 1" class="url">{{mobileUrl}}</div>

                    </div>
                    <span
                        class="app-config__setting-btn"
                        data-config="mobileEntry"
                        @click="setConfig('mobile')"
                        v-if="(moduleData.mobileUrlOnOff == 1) && isInstall"
                    >设置</span>
                </div>
            </div>
            <el-dialog
                :title="dialogTitle"
                :visible.sync="isShowDialog"
                :close-on-press-escape='false'
                width="600px"
                :lock-scroll="false"
                :close-on-click-modal='false'
                :modal-append-to-body='false'
            >
                <div>
                    <el-form
                        ref="form"
                        :model="formData"
                        :rules="formRules"
                        label-width="120px"
                    >
                        <el-form-item
                            v-if="type != 'ip'"
                            :label="dialogLabel"
                            prop="url"
                        >
                            <el-input
                                v-model.trim="formData.url"
                                style="width: 400px;"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            v-else
                            :label="dialogLabel"
                        >
                            <el-input
                                v-model.trim="formData.url"
                                style="width: 400px;"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span
                    slot="footer"
                    class="dialog-footer"
                >
          <el-button
              size="medium"
              @click="isShowDialog = false"
          >取 消</el-button>
          <el-button
              size="medium"
              type="primary"
              @click="setConfigConfirm"
          >确定</el-button>
        </span>
            </el-dialog>

            <el-dialog
                title="数据下发设置"
                :visible.sync="isShowPushDataDialog"
                :close-on-press-escape='false'
                width="600px"
                :lock-scroll="false"
                :close-on-click-modal='false'
                :modal-append-to-body='false'
            >
                <div>
                    <el-form
                        ref="pushDataForm"
                        :model="pushDataFormData"
                        :rules="pushFormRules"
                        label-width="120px"
                    >
                        <el-form-item label="是否开启" prop="onOff">
                            <el-switch :active-value="1" :inactive-value="2"
                                       v-model="pushDataFormData.callbackUrlOnOff"></el-switch>
                        </el-form-item>
                        <el-form-item
                            v-if="pushDataFormData.callbackUrlOnOff == 1"
                            label="回调地址"
                            prop="url"
                        >
                            <el-input
                                v-model.trim="pushDataFormData.url"
                                style="width: 400px;"
                            ></el-input>
                        </el-form-item>
                        <el-form-item v-if="pushDataFormData.callbackUrlOnOff == 1" label="接收下发内容">
                            <el-checkbox-group v-model="pushDataFormData.dataRange">
                                <el-checkbox v-if="moduleData.dataRange.includes(item.id)" :label="item.id"
                                             :key="item.id" v-for="item in dataRangeList">
                                    {{item.name}}
                                </el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-form>
                </div>
                <span
                    slot="footer"
                    class="dialog-footer"
                >
          <el-button
              size="medium"
              @click="isShowPushDataDialog = false"
          >取 消</el-button>
          <el-button
              size="medium"
              type="primary"
              @click="setPushDataConfigConfirm"
          >确定</el-button>
        </span>
            </el-dialog>

        </div>

    </div>
</template>

<script>
    import {queryApiNameByModuleId} from "@/api/apiPermission";
    import BackTool from "@/components/BackTool";
    import mixin from "@/mixins/windowResize";
    import Uploader from "@/components/Uploader/WebUploader";
    import {
        queryModuleById,
        queryIntegrateDetail,
        updateModuleSchoolByIp,
        updateModuleSchoolByPcUrl,
        updateModuleSchoolByMobileUrl,
        updateModuleSchool,
    } from "@/api/schoolManage";

    export default {
        name: "schoolAppIntDetail",
        components: {BackTool, Uploader},
        data() {
            const validateUrl = (rule, value, callback) => {
                this.formData.url = this.formData.url.trim();
                if (this.formData.url === "") {
                    callback(new Error("请填写url"));
                } else {
                    callback();
                }
            };
            const validateUrlPush = (rule, value, callback) => {
                this.pushDataFormData.url = this.pushDataFormData.url.trim();
                if (this.pushDataFormData.url === "") {
                    callback(new Error("请填写url"));
                } else {
                    callback();
                }
            };
            return {
                isInstall: this.$route.query.isOpen == 0 ? false : true,
                updateModuleSchoolShowDialog: false,
                updateModuleSchoolForm: {
                    moduleLogo: [],
                    moduleOtherName: "",
                },
                moduleLogo: "",
                moduleOtherName: "",
                updateModuleSchoolRules: {
                    moduleOtherName: [{required: true, message: "请输入应用名称"}],
                },
                id: this.$route.query.id,
                schoolId: this.$route.query.schoolId,
                type: "",
                isShowDialog: false,
                isShowPushDataDialog: false,
                moduleData: {},
                apiPermission: "",
                formData: {
                    url: "",
                },
                formRules: {
                    url: [{required: true, validator: validateUrl}],
                },
                pushDataFormData: {
                    url: '',
                    callbackUrlOnOff: 2,
                    dataRange: []
                },
                pushFormRules: {
                    url: [{required: true, validator: validateUrlPush}],
                },
                customIp: "",
                appSecret: "",
                pcUrl: "",
                mobileUrl: "",
                callbackUrlOnOff: 2,
                callbackUrl: '',
                dataRange: [],
                dataRangeList: [{
                    id: '1001',
                    name: '用户'
                }, {
                    id: '1002',
                    name: '用户部门变更'
                }, {
                    id: '1003',
                    name: '用户账号变更'
                }, {
                    id: '1004',
                    name: '部门'
                }, {
                    id: '1005',
                    name: '人脸'
                }, {
                    id: '1006',
                    name: '部门主任'
                }, {
                    id: '1007',
                    name: '教师任教'
                }, {
                    id: '1008',
                    name: '一卡通'
                }]
            };
        },
        computed: {
            dialogTitle() {
                let title = "";
                switch (this.type) {
                    case "pc":
                        title = "PC端单点登录设置";
                        break;
                    case "mobile":
                        title = "移动端单点登录设置";
                        break;
                    case "ip":
                        title = "自定义授信ip设置";
                        break;
                }
                return title;
            },
            dialogLabel() {
                let label = "";
                switch (this.type) {
                    case "pc":
                        label = "单点登录地址";
                        break;
                    case "mobile":
                        label = "单点登录地址";
                        break;
                    case "ip":
                        label = "ip";
                        break;
                }
                return label;
            },
        },
        mixins: [mixin],
        created() {
            this.getData();
            queryApiNameByModuleId({
                moduleId: this.id,
            }).then((data) => {
                this.apiPermission = data.join(",");
            });
        },
        methods: {
            jumpToPage(path, query) {
                if (query === undefined || query === null) {
                    query = {};
                }
                this.$router.push({
                    path,
                    query,
                });
            },
            getData() {
                queryModuleById({
                    moduleId: this.id,
                }).then((data) => {
                    data.mobileUrlOnOff = data.mobileUrlOnOff || 2;
                    data.callbackUrlOnOff = data.callbackUrlOnOff || 2;
                    data.pcUrlOnOff = data.pcUrlOnOff || 2;
                    data.dataRange = data.dataRange !== null ? data.dataRange.split(',') : [];
                    this.moduleData = data;
                });
                queryIntegrateDetail({
                    moduleId: this.id,
                    schoolId: this.schoolId,
                }).then((data) => {
                    console.log('data', data)
                    this.callbackUrlOnOff = data[0].callbackUrlOnOff || 2;
                    this.callbackUrl = data[0].callbackUrl || '';
                    this.dataRange = data[0].dataRange !== null ? data[0].dataRange.split(',') : [];

                    this.customIp = data[0].ip;
                    this.appSecret = data[0].appSecret;
                    this.pcUrl = data[0].pcUrl;
                    this.mobileUrl = data[0].mobileUrl;

                    this.moduleLogo = data[0].moduleLogo;
                    this.moduleOtherName = data[0].moduleOtherName;
                });
            },
            setPushDataConfigConfirm() {
                this.$refs.pushDataForm.validate((isValid) => {
                    if (isValid) {
                        const args = {
                            schoolId: this.schoolId,
                            moduleId: this.id,
                            callbackUrl: this.pushDataFormData.url,
                            callbackUrlOnOff: this.pushDataFormData.callbackUrlOnOff,
                            dataRange: this.pushDataFormData.dataRange.join(','),
                        };

                        updateModuleSchool(args)
                            .then(() => {
                                this.$message.success("设置成功");
                                this.isShowPushDataDialog = false;
                                this.getData();
                            });
                    }
                });
            },
            setConfig(type) {
                this.type = type;

                switch (type) {
                    case "pc":
                        this.formData.url = JSON.parse(JSON.stringify(this.pcUrl));
                        this.isShowDialog = true;
                        break;
                    case "mobile":
                        this.formData.url = JSON.parse(JSON.stringify(this.mobileUrl));
                        this.isShowDialog = true;
                        break;
                    case "ip":
                        this.formData.url = JSON.parse(JSON.stringify(this.customIp));
                        this.isShowDialog = true;
                        break;
                    case "callback":
                        this.pushDataFormData.url = this.callbackUrl ? JSON.parse(JSON.stringify(this.callbackUrl)) : JSON.parse(JSON.stringify(this.moduleData.callbackUrl));
                        this.pushDataFormData.callbackUrlOnOff = JSON.parse(JSON.stringify(this.callbackUrlOnOff));
                        this.pushDataFormData.dataRange = JSON.parse(JSON.stringify(this.dataRange));
                        this.isShowPushDataDialog = true;
                        break;
                }
            },
            setConfigConfirm() {
                this.$refs.form.validate((isValid) => {
                    if (isValid) {
                        const args = {
                            schoolId: this.schoolId,
                            moduleId: this.id,
                        };

                        new Promise((resolve) => {
                            switch (this.type) {
                                case "pc":
                                    args.pcUrl = this.formData.url;
                                    updateModuleSchoolByPcUrl(args).then(resolve);
                                    break;
                                case "mobile":
                                    args.mobileUrl = this.formData.url;
                                    updateModuleSchoolByMobileUrl(args).then(resolve);
                                    break;
                                case "ip":
                                    args.ip = this.formData.url;
                                    updateModuleSchoolByIp(args).then(resolve);
                            }
                        }).then(() => {
                            this.$message.success("设置成功");
                            this.isShowDialog = false;
                            this.getData();
                        });
                    }
                });
            },

            handleUpdateModuleSchool() {
                this.updateModuleSchoolShowDialog = true;
            },
            submitUpdateModuleSchool() {
                this.$refs["updateModuleSchoolForm"].validate((valid) => {
                    if (valid) {
                        let form = {
                            moduleId: this.id,
                            moduleLogo: this.moduleLogo || this.moduleData.logoUrl,
                            moduleOtherName: this.updateModuleSchoolForm.moduleOtherName,
                            schoolId: this.schoolId,
                            platformMsg: this.moduleData.platformMsg
                        };
                        console.log(form);
                        this.updateModuleSchool(form);
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            },
            updateModuleSchool(form) {
                updateModuleSchool(form)
                    .then((data) => {
                        console.log(data);
                        this.$message({
                            message: "保存成功",
                            type: "success",
                        });
                        this.updateModuleSchoolShowDialog = false;

                        this.updateModuleSchoolForm.moduleLogo = [];
                        this.updateModuleSchoolForm.moduleOtherName = "";

                        this.getData();
                        queryApiNameByModuleId({
                            moduleId: this.id,
                        }).then((data) => {
                            this.apiPermission = data.join(",");
                        });
                    })
                    .catch((msg) => {
                        this.$message({
                            message: msg,
                            type: "error",
                        });
                    });
            },
            logoUploadSuccessHandler(pic) {
                let form = {
                    moduleId: this.id,
                    moduleLogo: pic.fileUrl,
                    moduleOtherName: this.moduleOtherName,
                    schoolId: this.schoolId,
                    platformMsg: this.moduleData.platformMsg
                };
                console.log(form);
                this.updateModuleSchool(form);
            },
        },
    };
</script>

<style lang="scss" scoped>
    h4,
    p {
        margin: 0;
    }

    .schoolAppInteDetail {
        padding: 12px;
    }

    .top {
        border-bottom: 1px solid #e7eaec;
        padding-bottom: 10px;
    }

    .body {
        overflow: auto;
        padding-top: 10px;
    }

    .clear-div {
        clear: both;
    }

    .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        visibility: hidden;
        clear: both;
    }

    .wxcep-table pre {
        color: #c7254e;
    }

    /*============== applicationDetail.html ===========*/
    .application-info {
        margin-bottom: 10px;
    }

    .application-info .logo {
        width: 80px;
        height: 80px;
        vertical-align: middle;
        display: inline-block;
        margin-right: 10px;
    }

    .application-info .application-name {
        display: inline-block;
        vertical-align: middle;
    }

    .application-name__main {
        //   margin-bottom: 10px;
    }

    .application-name__desc {
        color: #888;
    }

    .detail-info {
        margin-top: 20px;
    }

    .detail-info__item {
        float: left;
        width: 36%;
        white-space: nowrap;

        margin-bottom: 20px;

        p {
            white-space: nowrap;
            max-width: 80%;
            vertical-align: middle;
            overflow-x: hidden;
            text-overflow: ellipsis;
        }
    }

    .app-config {
        border-radius: 5px;
        box-shadow: #999 0 0 10px;
        width: 30%;
        margin: 0 3% 33px 0;
        float: left;
        border: 1px solid #999;
        position: relative;
    }

    .app-config .app-config__title {
        border-bottom: 1px solid #999;
        padding: 10px;
        position: relative;
    }

    .app-config__title h4 {
        font-size: 20px;
        float: left;
        font-weight: bold;
    }

    .app-config__status {
        float: right;
        line-height: 22px;
    }

    .app-config__desc {
        padding: 20px 10px;
        min-height: 140px;
    }

    .app-config__setting-btn {
        position: absolute;
        right: 10px;
        bottom: 5px;
        color: #409eff;
        cursor: pointer;
    }

    .setting-btn {
        color: #409eff;
        cursor: pointer;
        margin-left: 20px;
    }

    /*=============== scanLoginIntro.html ========*/
    .intro-title {
        margin: 5px 0;
        font-size: 16px;
        font-weight: bold;
    }

    .detail-info__item {
        & > span {
            display: inline-block;
            text-align: right;
            width: 120px;
        }
    }

    .detail-info__item p {
        display: inline-block;
    }
</style>
<style lang="scss" scoped>
    .schoolAppInteDetail {
        .basic-info {
            display: flex;
            align-items: center;

            .logo-wrapper {
                position: relative;

                .file_box_wrap {
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    z-index: 10;
                    opacity: 0;
                }
            }
        }

        .ip-container {
            width: 75% !important;
            word-break: break-all !important;
            white-space: pre-wrap !important;
            vertical-align: top !important;
            max-width: 100% !important;
        }
    }
    .custom-ip-container {
        max-width: 80%;
        display: inline-block;
        overflow: hidden;
        vertical-align: top;
        text-overflow: ellipsis;
    }
    .setting-btn {
        display: inline-block;
        vertical-align: top;
        line-height: 18px;
        margin-left: 5px;
    }

    .url {
        word-break: break-all;
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolAppManage/schoolAppInteDetail.vue